<template>
  <div class="b">
    <Nav :current="current"></Nav>
    <div class="seatch">
      <div>
        <span>switchboardId:</span> <input type="text" v-model="switchboardId" />
      </div>
      <div><span>sign:</span> <input type="text" v-model="sign" /></div>
     <div>
        <span class="el-icon-search" @click="getCalcSign"></span>
      </div>
  </div>
    <div class="el-table-box">
      <el-table :data="tableData" style="width: 100%;margin-top: 10px" >
<!--          :max-height="tableHeight?tableHeight:0"-->
          <el-table-column
              :prop="col.prop"
              :label="col.label"
              :fixed="col.fixed"
              :width="col.width"
              :type="col.type"
              :min-width="col.minwidth"
              v-for="(col,index) in listCol"
              :key="index">
         
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="280">
          <template slot-scope="scope">
             <div  class="link-btn border-right l" @click="calcSignShow(scope.row)">
              详情
            </div>
            <div class="link-btn border-right l" @click="editcalcSign(scope.row)">
              编辑
            </div>
           
          </template>
        </el-table-column>
      </el-table>
    
     <div style="margin: 20px 0 80px 0;  text-align: center;" >
        <el-pagination
          background
          layout="total, sizes, prev, pager, next,jumper"
          :total="total"
          :current-page="currentPage"  
          :page-sizes="[10, 30, 50, 70, 100]"
          :page-size="pageSize"
          @size-change="changePageSize"
          @current-change="changeCurrentSize"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import Nav from "@/components/Nav.vue";
import apiData from "@/config/api";
import http from "@/config/httpConfig";
export default {
  components: {
    Nav,
  },
  props: {
    msg: String,
  },
  data() {
    return {
     tableHeight: 50,
      color:'#5DC5B8',
      current: '公司后台',
      isShowDelete: false,
      deleteObj: {}, //要删除的对象
      currentPage: 1,
      pageSize: 10,
      total: 10,
      switchboardId:'',
      sign:'',
      defaultProps: {
        //  列  :  显示的值
        date: "date",
        name: "name",
        address: "address",
      },
      tableData: [], //列表数据
      emptyText: "",
      //表格高度
      listCol: [
         {
          prop: "orderNum",
          label: "序号",
          width: "100",
          fixed: true,
          type: "index",
        },
          {
          prop: "id",
          label: "id",
          minwidth: "200",
         
        },
          {
          prop: "sign",
          label: "sign",
          minwidth: "300",
        },
         {
          prop: "switchboardId",
          label: "switchboardId",
          minwidth: "200",
          
        },
      ],
    };
  },
  mounted() {
    
    this.getCalcSign();
  },
  methods: {
   
    changePageSize(val) {
      this.pageSize = val;
      this.getCalcSign();
    },
    changeCurrentSize(val) {
      this.currentPage = val;
      this.getCalcSign();
    },

    getCalcSign() {
      let _this = this;
      let params = {
          pageNum: _this.currentPage,
          pageSize: _this.pageSize,
           switchboardId:_this.switchboardId,
            sign:_this.sign,
        };
      this.$nextTick(function () {
        this.clientHeight = `${document.documentElement.clientHeight}`;
        this.tableHeight = 800 + "px"
        http.get(apiData.calcSignList, true, params, (res) => {
      
          if(res.data.code == 200){
          _this.tableData = res.data.data.list;
          console.log(this.tableData)
          _this.total = res.data.data.totalRow;
            //  _this.$message.success(res.data.msg);

          }else{
             _this.$message.error(res.data.msg);
          }
        });
      });
    },
    calcSignShow(row){
      console.log(row.id);
      this.$router.push({ name: "CalcSignShow", query: { id: row.id } });

    },
    editcalcSign(row){
      this.$router.push({ name: "EditCalcSign", query: { id: row.id } });

    }

  }
};
</script>
<style slot-scope lang="less">
.b {
  margin: 0 10px;
}
.titleBox {
  margin: 20px auto;
  line-height: 30px;
  font-size: 16px;
  font-weight: bold;
  color: #333;
  .txt {
    display: inline-block;
    margin-right: 10px;
  }
}
.zitiyangshi{
  color: #5DC5B8;
  background: red;
}
.seatch-name{
  text-align: left;
  display: flex;
  input{
    width: 120px;
    height: 30px;
    padding-left: 5px;
    margin-left: 5px;
  }
  .el-icon-search{
    font-size: 20px;
    display: block;
    padding:5px  0 0 5px;
  }
}
.zitiyaoshi{
  color: #5DC5B8;
}
.el-table-column{
  color: #5DC5B8;
  background: red;
}
.blue{
  color: #5DC5B8;
}

.seatch {
  width: 100%;
  height: 30px;
  div {
    float: left;
    margin-right: 10px;
  }
  input {
    width: 120px;
    height: 30px;
    padding-left: 5px;
    margin-left: 5px;
  }
}
.el-icon-search {
    font-size: 20px;
    margin-top: 6px;
  }
</style>